import { Popup } from 'react-map-gl/mapbox'
import styles from './Tooltip.module.scss'

export default function Tooltip({ refugi, onClose, textos }) {
	const formatTipologia = (tipologia) => {
		if (!tipologia) return null
		const valorNet = tipologia.startsWith('_') ? tipologia.slice(1) : tipologia
		return valorNet.charAt(0).toUpperCase() + valorNet.slice(1)
	}

	return (
		<Popup
			longitude={refugi.longitude}
			latitude={refugi.latitude}
			anchor='bottom'
			onClose={onClose}
			closeOnClick={false}
			closeButton={false}
			style={{ maxWidth: 'none', width: 'auto', padding: '0px' }}
		>
			<div className={styles.container}>
				<header>{refugi.nom}</header>
				<div className={styles.fila}>
					{refugi.adreca && <p>{refugi.adreca}</p>}
					<p>{refugi.municipi}</p>
				</div>

				{refugi.tipologia && (
					<div className={styles.tipologia}>
						<strong>{textos.tipus_refugi}</strong>
						<span>{formatTipologia(refugi.tipologia)}</span>
					</div>
				)}

				<div className={styles.serveis}>
					<strong>{textos.label_serveis}</strong>
					<ul>
						{refugi?.accessibilitat && <li>Accessible</li>}
						{refugi?.aigua && <li>Aigua potable</li>}
						{refugi?.climatitzacio && <li>Climatització</li>}
						{refugi?.area_descans && <li>Àrea de descans</li>}
						{refugi?.lavabo && <li>Lavabos</li>}
					</ul>
				</div>
			</div>
		</Popup>
	)
}
